import React from "react";
import { NavLink } from "react-router-dom";
import { Calendar, Megaphone, Star, Layout, Store, QrCode } from "lucide-react";

const items = [
  { to: "/admin/bookings", label: "Bookings", icon: Calendar },
  { to: "/admin/content", label: "Content", icon: Layout },
  { to: "/admin/qr", label: "QR", icon: QrCode },
  { to: "/admin/promotions", label: "Promos", icon: Megaphone },
  { to: "/admin/reviews", label: "Reviews", icon: Star },
  { to: "/admin/business", label: "Shop", icon: Store },
];

export default function AdminMobileNav() {
  return (
    <nav data-testid="admin-mobile-nav"
         className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0F172A] text-[#FFFFFF] border-t border-[#D4AF37]/20 pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-6">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to}
                   className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[9px] uppercase tracking-widest ${isActive ? "text-[#D4AF37]" : "text-[#FFFFFF]/70"}`}>
            <Icon size={16}/>
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
